<template>
    <ui-modal id="edit-user" title="Editar Usuário" title-text="Informe os dados do novo usuário" size="md">
        <form v-on:submit.prevent="add">
            <div class="msg" v-if="message">{{message}}</div>
            <div class="input-box">
                <input id="input-nome" type="text" placeholder=" " v-model="form.first_name" @click="message = ''">
                <label for="input-nome">
                    <span>Nome</span>
                </label>
            </div>
            <div class="input-box">
                <input id="input-sobrenome" type="text" placeholder=" " v-model="form.last_name" @click="message = ''">
                <label for="input-sobrenome">
                    <span>Sobrenome</span>
                </label>
            </div>
            <div class="input-box">
                <input id="input-email" type="text" placeholder=" " v-model="form.email" @click="message = ''">
                <label for="input-email">
                    <span>E-mail</span>
                </label>
            </div>
            <div class="input-box input-select">
                <select id="input-role" v-model="form.role" @click="message = ''">
                    <option value="" selected>Selecione</option>
                    <option value="administrator">Administrador</option>
                    <option :value="role.slug" v-for="role in roles" :key="role.id">{{role.name}}</option>
                </select>
                <label for="input-role">
                    <span>Tipo de Usuário</span>
                </label>
            </div>
            <div class="input-box">
                <input id="input-senha" type="text" placeholder=" " v-model="form.password" @click="message = ''">
                <label for="input-senha">
                    <span>Senha</span>
                </label>
            </div>
            <div class="control">
                <button type="submit" :class="indicator">Salvar Alterações</button>
            </div>
        </form>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components'
    import { roles, user } from '@/services'
    export default {
        name: 'users',
        components: { uiModal },
        data() {
            return {
                roles: [],
                message: '',
                load: false,
                form: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    role: '',
                    password: '',
                }
            }
        },
        computed: {
            indicator(){
                return this.load ? 'load' : ''
            },
        },
        methods: {
            getRoles(){
                roles.read().then( response => {
                    this.roles = response.data
                })
            },
            add(){
                this.load = true
                user.update(this.form).then( () => {
                    this.load = false
                    this.$root.$emit('reloat-users');
                }, error => {
                    this.message = error.response.data.message
                    this.load = false
                })
            }
        },
        created(){
            this.getRoles()
            this.$root.$on("edit-user", (user) => {
                this.form = user
                this.$root.$emit('modal', 'edit-user');
			})
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
